// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1i0wY","load7":"_1ldy2"};